// import { shallowRef } from 'vue'

// 路由数据
const Layout = () => import("@/layout/index.vue");
const login = () => import("@/views/login/index");
const iframeView = () => import("@/views/taskManager/videoStreamIframe/index");
import personalIcon from '@/assets/images/personal.png'
import appIcon from '@/assets/images/appManager.png'
import taskIcon from '@/assets/images/task.png'
import alarmIcon from '@/assets/images/alarm.png'
import pushIcon from '@/assets/images/pushRecord.png'
import algorithmIcon from '@/assets/images/algorithm.png'
import systemIcon from '@/assets/images/system.png'
import collectIcon from '@/assets/images/collect.png'
import deviceIcon from '@/assets/images/device.png'
import alarmsAuditIcon from "@/assets/images/alarmsAudit.png";
import taskIcon2 from '@/assets/images/task2.png'
import statisticsIcon from "@/assets/images/statistics.png";
import alarmIcon2 from '@/assets/images/alarm2.png'
import audit from '@/assets/images/audit.png'
/**
 * @desc: 常量路由  不参与导航渲染
 * @param hidden boolean  是否参与界面导航渲染
 */
export const constantRoutes = [
  {
    path: "/",
    redirect: "/login",
    hidden: true,
  },
  {
    path: "/login",
    hidden: true,
    name: "login",
    component: login,
  },
  {
    path: "/landing",
    component: () => import("@/views/mobile/landing/index"),
    hidden: true,
    meta: {
      title: "landing",
      perms: "*",
    },
  },
  {
    path: "/screenBoard",
    component: () => import("@/views/screenBoard/index"),
    hidden: true,
    meta: {
      title: "screenBoard",
      perms: "*",
    },
  },
  {
    path: "/404",
    component: () => import("@/views/error/404/index"),
    hidden: true,
    meta: {
      title: "404",
      perms: "*",
    },
  },
  {
    path: "/401",
    component: () => import("@/views/error/401/index"),
    hidden: true,
    meta: {
      title: "401",
      perms: "*",
    },
  },
  {
    path: "/video-stream-iframe",
    hidden: true,
    name: "VideoStreamIframe",
    component: iframeView,
  },
];

// 动态路由(涉及权限/路由渲染)
/**
 * @desc: 动态路由(涉及权限/路由渲染)  参与路由渲染
 * @param
 *   hidden： boolean  是否参与底部导航路由渲染
 *   sideHidden: boolean  是否参与侧边导航路由渲染
 *   independent：String 是否需要独立将路由拆分
 *   windowId: 窗口id，用于 多视图独立窗口显示
 *   meta.type:  路由模式  子模块
 *   meta.rootPath: 根路由
 *   meta.rootPath：用于激活主系统路由样式
 *   meta.activeSide：父级隐藏的路由，用于令父级路由显示激活样式
 */
export const asyncRoutes = {
  path: "/index",
  component: Layout,
  redirect: "/home",
  isLayout: true,
  children: [
    {
      path: "/home",
      name: "home",
      hidden: true,
      meta: {
        title: "首页",
        icon: "iconfont icon-shouye",
        activeRoute: "/home",
        perms: "*", // 任意权限都可以进入
      },
    },
    {
      path: "/workbenches",
      name: "workbenches",
      hidden: true,
      meta: {
        title: "工作台",
        icon: "iconfont icon-shouye",
        rootPath: "workbenches",
        activeRoute: "/workbenches",
        perms: "*", // 任意权限都可以进入
        windowId: "workbenches",
      },
    },
    {
      path: "/personal",
      name: "personal",
      hidden: true,
      independent: "module", // 拆分子路由，独立为子模块
      meta: {
        title: "个人信息",
        icon: "iconfont icon-gerenxinxi",
        image: personalIcon,
        rootPath: "personal",
        activeRoute: "/personal",
        perms: "*",
        windowId: "personal",
      },
       children: [
        {
          path: "/personal/basic",
          name: "personalBasic",
          hidden: true,
          meta: {
            title: "基本信息",
            type: "module",
            rootPath: "/personal",
            perms: "*",
            namedViews: "personal",
          },
        },
        {
          path: "/personal/password",
          name: "personalPwd",
          hidden: true,
          meta: {
            title: "密码修改",
            type: "module",
            rootPath: "/personal",
            perms: "*",
            namedViews: "personal",
          },
        },
      ],
    },
    // 项目管理
    {
      path: "/appManager",
      name: "appManager",
      independent: "module", // 拆分子路由，独立为子模块
      meta: {
        title: "项目管理",
        type: "module",
        rootPath: "/appManager",
        activeRoute: "/appManager",
        icon: "iconfont icon-yingyong",
        image: appIcon,
        perms: "appManager",
        // perms: "*", // 任意权限都可以进入
        windowId: "appManager",
      },
      children: [
        {
          path: "/appManager/list",
          name: "appUpdate",
          hidden: true,
          sideHidden: true,
          meta: {
            title: "项目管理",
            type: "module",
            rootPath: "/appManager",
            perms: "appManager",
            namedViews: "appManager",
          },
        },
        {
          path: "/appManager/upsert",
          name: "appUpdate",
          hidden: true,
          sideHidden: true,
          meta: {
            title: "项目添加",
            type: "module",
            rootPath: "/appManager",
            perms: "appManager",
            namedViews: "appManager",
          },
        },
      ],
    },

    //设备管理
    {
          path: "/deviceManager",
          name: "device",
          hidden: false,
          meta: {
            title: "设备管理",
            type: "module",
            rootPath: "/deviceManager",
            activeRoute: "/deviceManager",
            icon: "iconfont icon-xitongguanli",
            image: deviceIcon,
            perms: "deviceManager",
            windowId: "deviceManager",
          },
    },


        /*
    * v3.0.0 开始进行系统模块重构
    * */
   //数据源管理
   {
    path: "/dataSourceManagement",
    name: "dataSourceManagement",
    hidden: false,
    meta: {
      title: "数据源管理",
      type: "module",
      rootPath: "/dataSourceManagement",
      activeRoute: "/dataSourceManagement",
      icon: "iconfont icon-xitongguanli",
      image: alarmIcon2,
      perms: "dataSourceManagement",
      windowId: "dataSourceManagement",
    },
  },


 // 任务管理
  {
    path: "/taskManagement",
    name: "taskManagement",
    hidden: false,
    meta: {
      title: "任务管理",
      type: "module",
      rootPath: "/taskManagement",
      activeRoute: "/taskManagement",
      icon: "iconfont icon-renwu",
      image: taskIcon,
      perms: "taskManagement",
      windowId: "taskManagement",
    },
  },

//事件管理
  {
    path: "/alarmEventsManagement",
    name: "alarmEventsManagement",
    hidden: false,
    meta: {
      title: "事件管理",
      type: "module",
      rootPath: "/alarmEventsManagement",
      activeRoute: "/alarmEventsManagement",
      icon: "iconfont icon-xitongguanli",
      image: taskIcon2,
      perms: "alarmEventsManagement",
      windowId: "alarmEventsManagement",
    },
  },

  


    // 任务管理
    // {
    //   path: "/taskManager",
    //   name: "taskManager",
    //   independent: "module", // 拆分子路由，独立为子模块
    //   meta: {
    //     title: "任务管理",
    //     icon: "iconfont icon-renwu",
    //     image: taskIcon,
    //     rootPath: "taskManager",
    //     activeRoute: "/taskManager",
    //     perms: "*", //"taskManagement",
    //     windowId: "taskManager",
    //   },
    //   children:[
    //     {
    //       path: "/taskManager/list",
    //       name: "taskManagerList",
    //       hidden: false,
    //       sideHidden: false,
    //       meta: {
    //         title: "任务管理",
    //         type: "module",
    //         rootPath: "/taskManager",
    //         perms: "taskManager",
    //         namedViews: "taskManager",
    //       },
    //     },
    //     {
    //       path: "/taskManager/alarmList",
    //       name: "taskManagerAlarmList",
    //       hidden: true,
    //       sideHidden: true,
    //       meta: {
    //         title: "告警信息",
    //         type: "module",
    //         rootPath: "/taskManager",
    //         perms: "taskManager",
    //         namedViews: "taskManager",
    //       },
    //     },
    //     {
    //       path: "/taskManager/addVideoStream",
    //       name: "taskManagerAddVideoStream",
    //       hidden: true,
    //       sideHidden: true,
    //       meta: {
    //         title: "添加实时视频流任务",
    //         type: "module",
    //         rootPath: "/taskManager",
    //         perms: "taskManager",
    //         namedViews: "taskManager",
    //       },
    //     },
    //     {
    //       path: "/taskManager/addImgVideo",
    //       name: "taskManagerAddImgVideo",
    //       hidden: true,
    //       sideHidden: true,
    //       meta: {
    //         title: "添加视频文件",
    //         type: "module",
    //         rootPath: "/taskManager",
    //         perms: "taskManager",
    //         namedViews: "taskManager",
    //       },
    //     }
    //   ]
    // },


      //审核任务
      {
        path: "/alarmReview",
        name: "alarmReview",
        // hidden: true,
        meta: {
          title: "审核任务",
          icon: "iconfont icon-quanju_jiguangtuisong",
          image: alarmsAuditIcon,
          rootPath: "alarmReview",
          activeRoute: "/alarmReview",
          // perms: "alarmManager",
          perms: "alarmReview",
          windowId: "alarmReview",
        },
      },


  //审核管理
  {
    path: "/auditTaskManagement",
    name: "auditTaskManagement",
    //hidden: true,
    // hidden: false,
    meta: {
      title: "审核管理",
      type: "module",
      rootPath: "/auditTaskManagement",
      activeRoute: "/auditTaskManagement",
      icon: "iconfont icon-renwu",
      image: audit,
      perms: "auditTaskManagement",
      windowId: "auditTaskManagement",
    },
  },

    //新告警管理
    //告警管理2.0
    {
      path: "/alarmManagementPlus",
      name: "alarmManagementPlus",
      hidden: false,
      meta: {
        title: "告警管理",
        // title: "告警管理2.0",
        icon: "iconfont icon-gaojing",
        image: alarmIcon,
        rootPath: "alarmManagementPlus",
        activeRoute: "/alarmManagementPlus",
        // perms: "*", // 任意权限都可以进入
        perms: "alarmManagementPlus",
        windowId: "alarmManagementPlus",
      },
    },

      //数据统计
   {
    path: "/statisticsManager",
    name: "statisticsManager",
    // hidden: true,
    // hidden: false,
    meta: {
      title: "数据统计",
      type: "module",
      rootPath: "/statisticsManager",
      activeRoute: "/statisticsManager",
      icon: "iconfont icon-renwu",
      image: statisticsIcon,
      perms: "statisticsManager",
      windowId: "statisticsManager",
    },
  },
  

    //系统管理
    {
      path: "/system",
      name: "system",
      independent: "module", // 拆分子路由，独立为子模块
      hidden: false,
      meta: {
        title: "系统管理",
        type: "module",
        rootPath: "/system",
        activeRoute: "/system",
        icon: "iconfont icon-xitongguanli",
        image: systemIcon,
        perms: "system",
        windowId: "system",
      },
      children: [
        {
          path: "/system/user",
          name: "user",
          hidden: true,
          sideHidden: false,
          meta: {
            title: "用户管理",
            type: "module",
            rootPath: "/system",
            perms: "systemAccount",
            namedViews: "system",
          },
        },
        {
          path: "/system/roles",
          name: "roles",
          hidden: true,
          sideHidden: false,
          meta: {
            title: "角色管理",
            type: "module",
            rootPath: "/system",
            perms: "systemRoles",
            namedViews: "system",
          },
        },
        {
          path: "/system/menu",
          name: "menu",
          hidden: true,
          sideHidden: false,
          meta: {
            title: "权限管理",
            type: "module",
            rootPath: "/system",
            perms: "adminFlag",
            namedViews: "system",
          },
        },
        // {
        //   path: "/system/record",
        //   name: "record",
        //   hidden: true,
        //   sideHidden: false,
        //   meta: {
        //     title: "日志管理",
        //     type: "module",
        //     rootPath: "/system",
        //     perms: "systemRecord",
        //     namedViews: "system",
        //   },
        // },

        // {
        //   path: "/system/upgrade",
        //   name: "upgrade",
        //   hidden: true,
        //   sideHidden: false,
        //   meta: {
        //     title: "升级管理",
        //     type: "module",
        //     rootPath: "/system",
        //     perms: "systemUpgrade",
        //     namedViews: "system",
        //   },
        // },
      ],
    },

  ],
};
